<ng-template #content>
    <img *ngIf="flagSrc" class="b-button__flag" [src]="flagSrc" alt="" />
    <i *ngIf="iconStart" w-icon>{{iconStart}}</i><span #labelTemplate>{{label}}<ng-content></ng-content></span><i
        *ngIf="iconEnd" w-icon>{{iconEnd}}</i>
</ng-template>
<ng-template [ngIf]="isIcon" #icon>
    <span class="b-icon" [ngClass]='iconClass'>{{matIcon(iconType)}}</span>
</ng-template>
<ng-template #dfacet>
    <!-- Dropdown from facet: little dance to ensure we create dropdown only if we have injected a facet with content -->
    <ng-template #a><ng-content select="f-facet[name=dropdown],[facet-dropdown]"
            description="generates a dropdown from included content"></ng-content></ng-template>
    <template #d><ng-container *ngTemplateOutlet="a"></ng-container></template>
    <!--  injected content is first in template, then move to dropdown; if any content we use the dropdown component -->
    <w-dropdown #dd [wToggle]="wClick"
        *ngIf="(d.content.childElementCount + (dropdown?.el?.childElementCount ?? 0) )> 0">
        <ng-container *ngTemplateOutlet="a"></ng-container>
    </w-dropdown>
    <!-- OR: display dropdown if included -->
    <ng-content select="w-dropdown,[facet-w-dropdown]" description="w-dropdown component if present"></ng-content>
</ng-template>

<ng-template [ngIf]="isText || isTertiary">
    <!-- include label -->
    <ng-container *ngTemplateOutlet="content"></ng-container>
    <!-- dropdown -->
    <ng-container *ngTemplateOutlet="dfacet"></ng-container>
</ng-template>
<ng-template [ngIf]="isIcon">
    <!-- no content, only dropdown -->
    <ng-container *ngTemplateOutlet="dfacet"></ng-container>
</ng-template>
